// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_au-4";
export var collapsed = "_au-1";
export var headerBar = "_au-0";
export var leftHeaderContent = "_au-3";
export var subjectContainer = "_au-2";